module.exports = __webpack_public_path__ + "img/centered-logo-nav-kia.6518c7df.png";